// No React here: the media-player server loader reaches this through the
// standout markers.

/**
 * Supported RoughNotation annotation types. A value, not just a type, so data
 * from the BE (a plain string) can be checked against it.
 */
export const ROUGH_NOTATION_TYPES = [
  'highlight',
  'underline',
  'strike-through',
  'box',
  'circle',
  'bracket',
  'crossed-off',
] as const;

export type RoughNotationType = (typeof ROUGH_NOTATION_TYPES)[number];

/** Sides a `bracket` annotation can draw on. */
export const ROUGH_NOTATION_BRACKETS = [
  'left',
  'right',
  'top',
  'bottom',
] as const;

export type RoughNotationBracket = (typeof ROUGH_NOTATION_BRACKETS)[number];
